import {useCallback, useEffect} from 'react';

const BACK_NAVIGATION_BUFFER = 10;

interface UseBackButtonHandlerProps {
	setExitModal: (value: boolean) => void;
	shouldOpenModal: boolean;
}

export function useBackButtonExitModal({setExitModal, shouldOpenModal}: UseBackButtonHandlerProps) {
	const urlChangeHandler = useCallback((replace = false) => {
		const historyMethod = replace ? 'replaceState' : 'pushState';
		for (let i = 0; i < BACK_NAVIGATION_BUFFER; i += 1) {
			window.history[historyMethod](null, '');
		}
	}, []);

	useEffect(() => {
		urlChangeHandler();
	}, [urlChangeHandler]);

	useEffect(() => {
		const handlePopState = (event: PopStateEvent) => {
			if (shouldOpenModal) {
				event.preventDefault();
				setExitModal(true);
			} else {
				window.history.back();
			}
		};

		window.addEventListener('popstate', handlePopState);
		urlChangeHandler();

		return () => {
			window.removeEventListener('popstate', handlePopState);
		};
	}, [shouldOpenModal, setExitModal, urlChangeHandler]);
}
